import React, { useState } from "react";
import { Link } from "react-router-dom";
import LogoAnimated from "../components/LogoAnimated";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header className="fixed top-0 left-0 w-full z-50 flex items-center justify-between whitespace-nowrap border-b border-solid border-[var(--secondary-color)] bg-white px-4 md:px-10 py-4 shadow backdrop-blur-sm">
      <Link to="/" className="logo-container flex items-center gap-2 text-2xl font-bold tracking-tight">
        {/* Logo SVG */}
        <LogoAnimated />
      </Link>
      {/* Desktop Menu */}
      <nav className="hidden md:flex flex-1 items-center justify-end gap-6">
        <a className="text-sm font-medium text-[var(--text-primary)] hover:text-[var(--primary-color)]" href="#about">About</a>
        <a className="text-sm font-medium text-[var(--text-primary)] hover:text-[var(--primary-color)]" href="#">Law Firms</a>
        <a className="text-sm font-medium text-[var(--text-primary)] hover:text-[var(--primary-color)]" href="#contact">Contact Us</a>
        <a className="rounded-md bg-[var(--primary-color)] px-4 py-2 text-sm font-medium text-white hover:bg-opacity-90" href="/login">Login</a>
      </nav>
      {/* Burger Icon for Mobile */}
      <button
        className="md:hidden flex items-center justify-center p-2 rounded focus:outline-none"
        aria-label="Open menu"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span className="material-symbols-outlined text-3xl">menu</span>
      </button>
      {/* Mobile Menu Drawer */}
      {menuOpen && (
        <div className="fixed inset-0 z-50 w-screen h-screen bg-white" onClick={() => setMenuOpen(false)}>
          <nav
            className="absolute top-0 left-0 w-full h-full bg-white flex flex-col gap-6 p-8"
            onClick={e => e.stopPropagation()}
          >
            <button className="self-end mb-4" aria-label="Close menu" onClick={() => setMenuOpen(false)}>
              <span className="material-symbols-outlined text-2xl">close</span>
            </button>
            <a className="text-lg font-medium text-[var(--text-primary)] hover:text-[var(--primary-color)] bg-white px-4 py-2 rounded" href="#about" onClick={() => setMenuOpen(false)}>About</a>
            <a className="text-lg font-medium text-[var(--text-primary)] hover:text-[var(--primary-color)] bg-white px-4 py-2 rounded" href="#" onClick={() => setMenuOpen(false)}>Law Firms</a>
            <a className="text-lg font-medium text-[var(--text-primary)] hover:text-[var(--primary-color)] bg-white px-4 py-2 rounded" href="#contact" onClick={() => setMenuOpen(false)}>Contact Us</a>
            <a className="rounded-md bg-[var(--primary-color)] px-4 py-2 text-lg font-medium text-white hover:bg-opacity-90" href="/login" onClick={() => setMenuOpen(false)}>Login</a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
